import React from "react";
import { Link, useParams } from "react-router-dom";
import { PageShell } from "@/components/layout/PageShell";
import { Seo } from "@/components/seo/Seo";

export function PayFailed() {
  const { orderId } = useParams<{ orderId: string }>();
  return (
    <PageShell
      title="We didn't receive your gift."
      subtitle="The card was declined or the session expired before the payment completed."
      stewardship="Give · failed"
    >
      <Seo title="Payment did not complete" description="" path={`/give/${orderId ?? ""}/failed`} noindex />
      <div className="max-w-xl">
        <p className="font-serif text-base text-ink-2 leading-relaxed mb-6">
          No funds were taken. You can try again, or wire the gift directly &mdash;
          instructions on the Foundation site.
        </p>
        <p className="font-mono text-xs text-ink-3 mb-8">Donation #{orderId}</p>
        <div className="flex flex-wrap gap-3">
          <Link
            to={`/give/${orderId}`}
            className="bg-ink text-paper px-6 py-3 font-mono text-xs uppercase tracking-widest hover:bg-ink-2"
          >
            Try again
          </Link>
          <Link
            to="/foundation/contribute#general-gift"
            className="border border-ink text-ink px-6 py-3 font-mono text-xs uppercase tracking-widest hover:bg-paper-2"
          >
            Wire instead
          </Link>
        </div>
      </div>
    </PageShell>
  );
}
